import type { RequestSettings } from '@core/entities/RequestSettings';
import type {
  RequestSettingsDefaults,
  RequestSettingsRepository,
} from '@core/repositories/RequestSettingsRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';
import {
  toRequestSettings,
  type RequestSettingsResponse,
} from '@infrastructure/mappers/requestSettingsMapper';

interface DefaultsResponse {
  app_defaults: RequestSettingsResponse;
  unsupported: Record<string, string>;
}

export class RequestSettingsRepositoryImpl implements RequestSettingsRepository {
  async getDefaults(): Promise<RequestSettingsDefaults> {
    try {
      const response = await httpClient.get<{ data: DefaultsResponse }>(
        '/request-settings/defaults',
      );
      return {
        appDefaults: toRequestSettings(
          response.data.data.app_defaults,
        ) as Required<RequestSettings>,
        unsupported: response.data.data.unsupported,
      };
    } catch (error) {
      throw toAppError(error);
    }
  }
}
